import { A4uClose as IconComponent } from '@adobe/react-spectrum-workflow/dist/Close.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Close(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}